import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../../helpers/utility';

const initialState = {
  error: null,
  loading: false,
  notes: '',
};

const agentNotesStart = (state, action) => {
  return updateObject(state, {loading: true});
};

const agentNotesSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
    notes: action.notes,
  });
};

const agentNotesFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false});
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AGENT_NOTES_START:
      return agentNotesStart(state, action);
    case actionTypes.AGENT_NOTES_SUCCESS:
      return agentNotesSuccess(state, action);
    case actionTypes.AGENT_NOTES_FAIL:
      return agentNotesFail(state, action);
    default:
      return state;
  }
};

export default reducer;